export default "__VITE_ASSET__LrWh0GvD__"